import React from 'react';

import Textfield from '@atlaskit/textfield/text-field';

export default function TextFieldAppearanceStandard(): React.JSX.Element {
	// eslint-disable-next-line @atlaskit/design-system/no-placeholder
	return <Textfield appearance="standard" label="Standard" placeholder="" />;
}
